<template>
  <a
    v-if="isExternal"
    :href="to"
    target="_blank"
    :class="$style.controller"
  >
    <slot />
  </a>
  <NavLink
    v-else
    :to="normalize(`/${to}`)"
    :class="$style.controller"
  >
    <slot></slot>
  </NavLink>
</template>

<script lang="ts" setup>
import { normalize } from "~/utils/url/normalize";

const props = defineProps<{
  to?: string;
}>();

const { to } = toRefs(props);
const isExternal = computed<boolean>(() => !!to.value?.startsWith("http"));
</script>

<style lang="scss" module>
.controller {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 32px;
  height: 60px;
  font-size: 18px;
  line-height: 60px;
  font-weight: 500;
  padding: 0px 24px;
  border-radius: 18px;
  color: var(--general-background);
  background-color: var(--button-filled-default);
  transition: all 0.25s linear;

  &:hover {
    background-color: var(--button-filled-hover);
  }

  &:active {
    background-color: var(--button-filled-active);
  }

  @media screen and (max-width: 1000px) {
    bottom: 20px;
    height: 48px;
    font-size: 16px;
    line-height: 48px;
  }
  @media screen and (max-width: 800px) {
    position: relative;
    bottom: 24px;
  }
}
</style>
